export default __webpack_public_path__ + "4209f3a25d37fb3e88b72deb9ae65266.png";